export const textVariants = {
    default: {
        fontSize: 'xl',
        fontWeight: 'regular',
        lineHeight: 'xl',
    },
    inherit: {
        fontSize: 'inherit',
        fontWeight: 'inherit',
        lineHeight: 'inherit',
    },
    megaBold: {
        fontSize: 'mega',
        fontWeight: 'semiBold',
        lineHeight: 'mega',
        fontFeatureSettings: "'ss01' on, 'ss02' on",
        letterSpacing: '-0.02rem',
    },
    mega: {
        fontSize: 'mega',
        fontWeight: 'regular',
        lineHeight: 'mega',
    },
    xxxxlBold: {
        fontSize: 'xxxxl',
        fontWeight: 'semiBold',
        letterSpacing: '-0.02rem',
        fontFeatureSettings: "'ss06' on",
        lineHeight: 'xxxxl',
    },
    xxxxl: {
        fontSize: 'xxxxl',
        fontWeight: 'regular',
        lineHeight: 'xxxxl',
    },
    xxxxlLight: {
        fontSize: 'xxxxl',
        fontWeight: 'light',
        lineHeight: 'xxxxl',
    },
    xxxlBold: {
        fontSize: 'xxxl',
        fontWeight: 'semiBold',
        letterSpacing: '-0.02rem',
        lineHeight: 'xxxl',
    },
    xxxl: {
        fontSize: 'xxxl',
        fontWeight: 'regular',
        lineHeight: 'xxxl',
    },
    xxxlLight: {
        fontSize: 'xxxl',
        fontWeight: 'light',
        lineHeight: 'xxxl',
    },
    xxlBold: {
        fontSize: 'xxl',
        fontWeight: 'semiBold',
        letterSpacing: '-0.02rem',
        lineHeight: 'xxl',
    },
    xxl: {
        fontSize: 'xxl',
        fontWeight: 'regular',
        lineHeight: 'xxl',
    },
    xxlLight: {
        fontSize: 'xxl',
        fontWeight: 'light',
        lineHeight: 'xxl',
    },
    xlBold: {
        fontSize: 'xl',
        fontWeight: 'semiBold',
        letterSpacing: '-0.02rem',
        lineHeight: 'xl',
    },
    xl: {
        fontSize: 'xl',
        fontWeight: 'regular',
        lineHeight: 'xl',
    },
    xlLight: {
        fontSize: 'xl',
        fontWeight: 'light',
        lineHeight: 'xl',
    },
    lBold: {
        fontSize: 'l',
        fontWeight: 'semiBold',
        lineHeight: 'l',
    },
    l: {
        fontSize: 'l',
        fontWeight: 'regular',
        lineHeight: 'l',
    },
    lLight: {
        fontSize: 'l',
        fontWeight: 'light',
        lineHeight: 'l',
    },
    mBold: {
        fontSize: 'm',
        fontWeight: 'semiBold',
        lineHeight: 'm',
    },
    m: {
        fontSize: 'm',
        fontWeight: 'regular',
        lineHeight: 'm',
    },
    sBold: {
        fontSize: 's',
        fontWeight: 'semiBold',
        lineHeight: 's',
    },
    s: {
        fontSize: 's',
        fontWeight: 'regular',
        lineHeight: 's',
    },
    xsBold: {
        fontSize: 'xs',
        fontWeight: 'semiBold',
        lineHeight: 'xs',
    },
    xs: {
        fontSize: 'xs',
        fontWeight: 'regular',
        lineHeight: 'xs',
    },
    xxsBold: {
        fontSize: 'xxs',
        fontWeight: 'semiBold',
        lineHeight: 'xxs',
    },
    xxs: {
        fontSize: 'xxs',
        fontWeight: 'regular',
        lineHeight: 'xxs',
    },
};
//# sourceMappingURL=data:application/json;base64,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